module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Border-5b889c6c648f1a38b45ac12f6625a00c.svg";